// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1IOgG","header":"Messages_header__2yR38"};